import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import ga4Events from '../../ga4Events';

const Breakpoints = {
  320: {
    slidesPerView: 2.2,
    spaceBetween: 15,
  },
};

const textItems = [
  'Wonderful Images',
  'Interactive Story',
  'Voice Over',
  'Record own Voice',
];

function Textlist() {
  return (
    <>
      <div className="text_list_section row_am" id="text_list" data-aos="fade-in" data-aos-duration={1500} data-aos-once>
        <div className="container">
          <span className="title_badge down_fix">Why choose our app</span>
        </div>
        <div className="slider_block">
          <Swiper
            className="swiper-wrapper"
            id="text_list_flow"
            slidesPerView={2.1}
            breakpoints={Breakpoints}
            onSlideChangeTransitionEnd={(swiper) => {
              ga4Events.textSlider.sliderSwipe(swiper.activeIndex);
            }}
          >
            {textItems.map((item, index) => (
              <SwiperSlide key={index} className="item">
                <div className="text_block">
                  <span>{item}</span>
                  <span className="mark_star">•</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
}

export default Textlist;
